module.exports = __webpack_public_path__ + "static/media/avataaars (4).a48034da.svg";